import { Injectable } from '@angular/core';
import { ToastComponent } from './toast.component';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastComponent: ToastComponent | null = null;

  register(toast: ToastComponent) {
    this.toastComponent = toast;
  }

  show(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'success', retry = 0) {
    if (this.toastComponent) {
      this.toastComponent.show(message, type);
    } else if (retry < 10) {  // solo intenta 10 veces
      setTimeout(() => this.show(message, type, retry + 1), 100);
    } else {
      console.error('❌ No se pudo mostrar el toast: ToastComponent no registrado.');
    }
  }
}
